import styled from 'styled-components';
import { Container, GridCell } from 'styles';
import SVG from 'react-inlinesvg';
import { Button as ShrikeButton, Card } from '@perch-labs/shrike';

export const Button = styled(ShrikeButton)`
  text-align: left;

  ${props => props.theme.media.small` && {
      width: auto;
    }
  `}
`;

export const CardHeader = styled(Card.Header)`
  display: block;
`;

export const CardContent = styled(Card.Content)`
  padding-left: 0;
  padding-right: 0;
`;

export const HeroGridCell = styled(GridCell).attrs({
  columns: 12,
  margin: { top: '-24px' },
  small: { columns: 8, margin: { bottom: '-24px', top: '0' } },
})``;

const footerAttrs = () => ({
  alignItems: 'center',
  direction: 'column',
  flex: true,
});

export const Footer = styled(Container).attrs(footerAttrs)`
  padding-top: 40px;
`;

export const StyledSVG = styled(SVG)`
  margin: 48px 0 -48px;

  ${props => props.theme.media.medium`
    margin: 32px 0 -32px;
  `}
`;
